module.exports = __webpack_public_path__ + "static/img/064.14c30ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/064.jpg
// module id = LeHw
// module chunks = 0